import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card, CardContent } from '@/components/ui/card';
import { adminLogin } from '@/lib/api';
import { toast } from 'sonner';
import { Home } from 'lucide-react';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const login = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await adminLogin(username, password);
      sessionStorage.setItem(
        '0middle_admin_token',
        response.data.access_token
      );
      sessionStorage.setItem(
        '0middle_admin_username',
        response.data.username || username
      );
      navigate('/admin');
    } catch (error) {
      console.error(error);
      toast.error(
        error?.response?.data?.detail ||
          'Unable to sign in'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <Card className="w-full max-w-md">
        <CardContent className="p-6">
          <div className="flex items-start justify-between gap-4 mb-1">
            <div className="flex items-center gap-3">
              <img
                src="/0middle-logo.svg"
                alt="0middle logo"
                className="w-10 h-10 object-contain"
              />
              <div>
                <h1
                  className="text-2xl font-semibold tracking-tight"
                  style={{ fontFamily: "'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" }}
                >
                  <span
                    className="font-bold"
                    style={{ fontFamily: "'SF Mono', Menlo, Consolas, monospace", fontVariantNumeric: 'slashed-zero', fontFeatureSettings: "'zero' 1" }}
                  >
                    0
                  </span>
                  middle Admin
                </h1>
                <p className="text-sm text-muted-foreground">
                  Internal access only
                </p>
              </div>
            </div>

            <Button
              type="button"
              onClick={() => navigate('/')}
              className="gap-2 shrink-0"
            >
              <Home className="w-4 h-4" />
              Home
            </Button>
          </div>

          <form onSubmit={login} className="space-y-4">
            <div>
              <label className="text-sm font-medium">
                User name
              </label>
              <select
                className="w-full border rounded-md h-10 px-3 bg-background mt-1"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                autoComplete="username"
              >
                <option value="">Select user</option>
                <option value="Anu">Anu</option>
                <option value="Dinesh">Dinesh</option>
                <option value="Muthu">Muthu</option>
                <option value="Siva">Siva</option>
              </select>
            </div>

            <div>
              <label className="text-sm font-medium">
                Admin password
              </label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                className="mt-1"
              />
            </div>

            <Button
              className="w-full"
              disabled={loading || !username || !password}
            >
              {loading ? 'Signing in...' : 'Sign in'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminLogin;
